import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProgressBarContainer, Item  } from './styles';
import { CheckInIcon, IdentityIcon, CreditCardIcon, KeycardIcon } from 'assets/icons';

const ProgressBar = ({step, groupId, status}) => {

  const navigate = useNavigate();

  useEffect(() => {
    if(status) {
      if (status === "CHECKED_IN") {
        navigate(`/group-check-in/print-key/${groupId}`);
      } else if (status !== "PENDING" ) {      
        navigate(`/booking-details/${groupId}`);
      }
    }
  }, [status, navigate, groupId]);

  return (
    <ProgressBarContainer>
      <Item
        highlight={step === 1}
        onClick ={() => navigate(`/group-check-in/early-check-in/${groupId}`)}
      >
        <CheckInIcon />
        Early Checkin
      </Item>
      <hr className="divider" />
      <Item
        highlight={step === 2}
        onClick ={() => navigate(`/group-check-in/confirm-identity/${groupId}`)}
      >
        <IdentityIcon />
        Identification 
      </Item>
      <hr className="divider" />
      <Item
        highlight={step === 3}
        onClick ={() => navigate(`/group-check-in/payment/${groupId}`)}
      >
        <CreditCardIcon />
        Payment
      </Item>
      <hr className="divider" />
      <Item
        highlight={step === 4}
        onClick ={() => navigate(`/group-check-in/print-key/${groupId}`)}
      >
        <KeycardIcon />
        Print Key
      </Item>
    </ProgressBarContainer>
  )
}

export default ProgressBar;